import React from "react";
import PropTypes from "prop-types";
import { DialysisDragDropContext } from "../DialysisDragDrop.utils";
import { DIALYSIS_TYPE } from "../DialysisDragDrop.constants";
import { DialysisBand } from "../DialysisBand";

export function DialysisPath(props) {
  const {
    state,
    onDragOver,
    getDialysisValue,
    onStripDrop,
    isMultiDialysisHolder,
  } = React.useContext(DialysisDragDropContext);

  const TYPE = "DIALYSIS_PATH";

  const style = {
    height: `${state.dialysisPathHeight}px`,
    padding: `${state.dialysisPathPadding}px 0px`,
  };

  const isDraggableBand = (dialysis) =>
    dialysis.dialysisType === DIALYSIS_TYPE.DRAGGABLE;

  const setInnerText = (dialysis) => {
    if (dialysis.dialysisType === DIALYSIS_TYPE.LABEL)
      return `${dialysis.value} bp`;
    if (isMultiDialysisHolder && isDraggableBand(dialysis))
      return `${dialysis.dialysisId + 1}`;
    return null;
  };

  const renderDialysisBand = (dialysisBand) => (
    <DialysisBand
      id={props.id}
      key={dialysisBand.dialysisId}
      type={TYPE}
      dialysisId={`${props.cellId}_${dialysisBand.dialysisId}`}
      dialysisType={dialysisBand.dialysisType}
      height={dialysisBand.height}
      opacity={dialysisBand.opacity}
      value={dialysisBand.value}
      columnType={props.columnType}
      className={`${props.className}__band`}
      options={dialysisBand.options}
      selectedOption={dialysisBand.selectedOption}
      selected={dialysisBand.selected}
      label={props.label}
      tabIndex={props.tabIndex}
      feedbackType={props.feedbackType}
      responses={props.responses}
    >
      {setInnerText(dialysisBand)}
    </DialysisBand>
  );

  const onDrop = (event) => {
    let value = parseInt(Math.round(getDialysisValue(event)));
    value = value >= state.rangeBottom ? value : state.rangeBottom;
    value = value >= state.rangeTop ? state.rangeTop : value;
    onStripDrop({
      event,
      id: props.id,
      cellId: props.cellId,
      value,
      label: props.label,
    });
  };

  return (
    <div
      style={style}
      className={props.className}
      onDragOver={onDragOver}
      onDrop={onDrop}
      tabIndex={props.tabIndex}
    >
      {props.cellItems.map(renderDialysisBand)}
    </div>
  );
}

DialysisPath.propTypes = {
  /**
   * Component id from the notebook data file
   */
  id: PropTypes.number,
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * Unique Id for the cell
   */
  cellId: PropTypes.string,
  /**
   * ColumnType mention which typeof column
   */
  columnType: PropTypes.string,
  /**
   * List of DialysisItems to be renderd heree
   */
  cellItems: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for Dialysis
       */
      dialysisId: PropTypes.number,
      /**
       * Type of Dialysis-Strip
       */
      dialysisType: PropTypes.oneOf(Object.keys(DIALYSIS_TYPE)),
      /**
       * Height value go Dialysis
       */
      height: PropTypes.number,
      /**
       * Opacity value of Dialysis
       */
      opacity: PropTypes.number,
      /**
       * Postion value of Dialysis
       */
      value: PropTypes.number || null,
      /**
       * Boolean to set if dialysis band is selected
       */
      selected: PropTypes.bool,
    })
  ),
  /**
   * Tabindex value passed from outside the component for keyboard navigation
   */
  tabIndex: PropTypes.number,
};

DialysisPath.defaultProps = { tabIndex: 0 };
